var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m82.812 89.062h-71.875v-71.875h32.812v3.125h-29.688v65.625h65.625v-29.688h3.125z",
    fill: "#003102"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m67.773 51.367h-19.141v-19.141h3.125v16.016h16.016z",
    fill: "#003102"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m79.984 17.801 2.2109 2.2109-30.938 30.938-2.2109-2.2109z",
    fill: "#003102"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIn);
export default __webpack_public_path__ + "static/media/move-in.14ab7017.svg";
export { ForwardRef as ReactComponent };